export default __webpack_public_path__ + "static/media/ppoSlider2.3ca19222.png";